import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useDispatch, useSelector } from "react-redux";
import { checkEmail, logout } from "../../store/authSlice";
import { useNotification } from "../Notifications/Notifications";
import { resetFormData } from "../../store/supplierFormDataSlice";
import { resetBuyerFormData } from "../../store/buyerFormDataSlice";
import { resetPersonalInfoFormData } from "../../store/personalInfoSlice";

const LoginHeader = ({
  loginPage,
  landingPage,
  emailChecked,
  isPasswordSet,
  isAuthenticated,
  registrationPage,
  isDashboard,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [newNotification, setNewNotification] = useState(false);
  const { notifications, removeNotification } = useNotification();
  const profile = useSelector((state) => state.auth.profile);
  const accountType = profile?.accountType;
  const notificationRef = useRef();
  const [isScrolled, setIsScrolled] = useState(false);
    const { buyerId, isParamsExist } = useSelector((state) => state.params);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleNotificationClick = (event) => {
    event.stopPropagation();
    setShowNotification((prev) => !prev);
    setNewNotification(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeleteNotifications = (id) => {
    removeNotification(id);
    if (notifications.length === 1) {
      setShowNotification(false);
    }
  };

  const handleAuthNavigation = (isSignUp) => {
    if (isSignUp) {
      if (isParamsExist && buyerId) {
        navigate(`/signup?buyerId=${buyerId}`);
      } else {
        navigate("/signup");
      }
    } else {
      navigate("/login");
    }
  };

  // const handleLogout = () => {
  //   dispatch(resetFormData());
  //   dispatch(resetBuyerFormData());
  //   dispatch(resetPersonalInfoFormData());

  //   dispatch(logout());
  //   navigate("/login");
  // };
  const handleLogout = () => {
  navigate("/logout");
};


  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  return (
    <header
      role="banner"
      className={`flex justify-center md:justify-between items-center p-6 fixed top-0 z-[1000] w-full md:pl-6 md:pr-14 transition-all duration-300 ${
        landingPage ? "bg-transparent" : "bg-white shadow-md"
      }

              ${isScrolled && landingPage ? "bg-white " : "bg-transparent"}
      ${!landingPage ? "h-[70px]" : "h-[100px]"}
      `}
    >
      <a
        href="#main-content"
        className="absolute top-[-50px] left-2 px-4 bg-black text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
      >
        Skip to main content
      </a>

      <div
        className="w-full flex justify-start cursor-pointer"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
      >
        {!isDashboard && (
          <SourceIQLogo
            fill="#1E1E1E"
            width={!landingPage ? 120 : 150}
            height={!landingPage ? 24 : 30}
          />
        )}
      </div>

      {/* Hamburger Menu for Mobile */}
      <button
        aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        className="md:hidden p-2 text-gray"
        onClick={toggleMenu}
      >
        {isMenuOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        )}
      </button>

      {isAuthenticated ? (
        <div className="hidden md:flex flex-row justify-center items-center gap-10">
          <div className="relative cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleNotificationClick}
              className="mt-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14.9997 18V18.75C14.9997 19.5456 14.6837 20.3087 14.1211 20.8713C13.5585 21.4339 12.7954 21.75 11.9997 21.75C11.2041 21.75 10.441 21.4339 9.87842 20.8713C9.31581 20.3087 8.99974 19.5456 8.99974 18.75V18M20.0472 16.4733C18.8435 15 17.9936 14.25 17.9936 10.1883C17.9936 6.46875 16.0943 5.14359 14.531 4.5C14.3233 4.41469 14.1279 4.21875 14.0646 4.00547C13.7904 3.07219 13.0216 2.25 11.9997 2.25C10.9779 2.25 10.2086 3.07266 9.93724 4.00641C9.87396 4.22203 9.67849 4.41469 9.47084 4.5C7.90568 5.14453 6.00818 6.465 6.00818 10.1883C6.00584 14.25 5.15599 15 3.95224 16.4733C3.45349 17.0836 3.89037 18 4.76271 18H19.2415C20.1091 18 20.5432 17.0808 20.0472 16.4733Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            {showNotification && (
              <div
                className="absolute top-10 w-[383px] min-h-24 right-0 z-50 rounded-[11.471px] border border-[#ebebeb] bg-white shadow-[0px_4.588px_104.612px_-4.588px_rgba(0,0,0,0.1)] p-4 flex flex-col justify-between items-start"
                ref={notificationRef}
              >
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className="w-full flex justify-between items-center py-5 border-b last:border-b-0"
                  >
                    <div className="flex items-center justify-between w-full">
                      {/* Optional icon for notification */}
                      {/* <img src={notificationIcon} alt="" className="w-5 h-5 mr-3" /> */}
                      <div className="flex flex-col">
                        <p className="text-left text-sm font-semibold">
                          {notification.title}
                        </p>
                        <p className="text-left text-xs text-gray-500">
                          {notification.subtitle}
                        </p>
                      </div>
                      <button
                        className="text-gray-600 hover:text-gray-800 text-xl ml-4"
                        onClick={() =>
                          handleDeleteNotifications(notification.id)
                        }
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {newNotification && !showNotification && (
              <div className="absolute bottom-1 right-[-2px] w-3 h-3 bg-red-500 rounded-full"></div>
            )}
          </div>

          <div className="relative hidden md:flex">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => {
                showNotification && setShowNotification(false);
                setShowLogOut((prev) => !prev);
              }}
            >
              <div className=" w-8 h-8 rounded-full border border-[#215FC1] bg-[#D9D9D9]"></div>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path d="M7 10L12 15L17 10H7Z" fill="black" />
              </svg>
            </div>

            {showLogOut && (
              <>
                <ul
                  id="avatar-menu"
                  role="menu"
                  className={`absolute top-12 right-0 ${
                    showLogOut ? "block" : "hidden"
                  } bg-white border border-gray-300 rounded-[13px] shadow-md`}
                >
                  <li role="menuitem">
                    <button
                      onClick={handleLogout}
                      id="logout-button"
                      className="w-full text-left py-2 px-8 whitespace-nowrap text-base hover:bg-gray-100 rounded-[13px]"
                    >
                      Log out
                    </button>
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
      ) : (
        !registrationPage && (
          <button
            onClick={() => handleAuthNavigation(loginPage)}
            className={`hidden md:flex ${
              landingPage ? "h-14 px-8" : "h-10 px-4"
            } rounded-[13px] justify-center items-center gap-2 
            ${
              landingPage
                ? "bg-[#eaf524] cursor-pointer"
                : emailChecked && !isPasswordSet
                ? "bg-gray-400 cursor-not-allowed opacity-60"
                : "bg-[#eaf524] cursor-pointer"
            }
          `}
            aria-label="Log in"
            disabled={!landingPage && emailChecked && !isPasswordSet}
          >
            <span
              className="text-center text-base font-medium whitespace-nowrap"
              style={{ color: "#1E1E1E" }}
            >
              { loginPage
                ? "Create a new account"
                : "Login to account"}
              {/* {landingPage
                ? "Get Early Access to Smart Sourcing"
                : loginPage
                ? "Create a new account"
                : "Login to account"} */}
            </span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fillRule="none"
            >
              <path d="M12 7L0 14L6.05683e-07 0L12 7Z" fill="#1E1E1E" />
            </svg>
          </button>
        )
      )}

      {/* Hamburger Menu on Mobile */}
      {isMenuOpen && (
        <div
          role="navigation"
          className="fixed top-0 left-0 w-full h-[100vh] bg-white p-10"
          aria-label="Mobile menu"
        >
          <div className="flex justify-between items-center">
            <div
              className="cursor-pointer"
              onClick={() => navigate("/")}
              aria-label="Go to homepage"
            >
              <SourceIQLogo fill="#1E1E1E" width={150} height={30} />
            </div>
            <button
              aria-label="Close menu"
              onClick={toggleMenu}
              className="text-gray"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="mt-20 gap-6 flex flex-col justify-start">
            {/* Log In Link in Hamburger Menu */}
            <button
              onClick={() =>
                isAuthenticated
                  ? handleLogout()
                  : handleAuthNavigation(loginPage)
              }
              className="w-full text-left py-2 px-4 text-black font-bold text-3xl"
              aria-label="Log in"
            >
              {isAuthenticated
                ? "Log out"
                : "Log in"}
              
              {/* {landingPage
                ? "Get Early Access"
                : isAuthenticated
                ? "Log out"
                : loginPage
                ? "Sign up"
                : "Log in"} */}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default LoginHeader;